export default class CustomNotification extends HTMLElement {
    constructor() {
        super();
        this.stylesheet = this.getAttribute('stylesheet');
        this.notificationClass = this.getAttribute('notificationClass');
        this.newClasses = this.getAttribute('newClasses');
        this.showAlways = this.getAttribute('showAlways');
    }

    connectedCallback() {
        this._shadowRoot = this.attachShadow({mode: 'open'});
        const t = document.querySelector('#custom-notification');
        this.instance = t.content.cloneNode(true);
        this.instance.querySelector('[name="stylesheet"]').href = this.stylesheet;
        this.instance.querySelector('[name="stylesheet"]').addEventListener('load', () => {
            this.style.display = 'block';
        });

        if (this.notificationClass) {
            this.instance.querySelector('[name="customNotification"]').className += this.notificationClass;
        }

        if (this.newClasses) {
            this.instance.querySelector('[name="customNotification"]').className = this.newClasses;
        }

        this.closeNotificationModal = this.instance.querySelector('[data-action="close-custom-notification"]');

        this._shadowRoot.appendChild(this.instance);

        this.customNotification = this._shadowRoot.querySelector('[name="customNotification"]');

        this.closeNotificationModal.onclick = e => {
            this.closeCustomNotification();
        };

        this.customNotification.addEventListener("transitionend", (event) => {
            this.hideNotification(event.currentTarget);
        });
        this._shadowRoot.querySelector('[name="stylesheet"]').addEventListener('load', () => {
            this.style.display = '';
        });
    }

    hideNotification(currentTarget) {
        if (currentTarget.classList.contains('hide-notification')) {
            if (this.showAlways) {
                currentTarget.classList.add('d-none');
            } else {
                currentTarget.style.display = 'none';
            }
            currentTarget.classList.remove('hide-notification');
        }
    }

    openCustomNotification() {
        this.customNotification.classList.remove('d-none');
        setTimeout((event) => { this.customNotification.classList.add('active'); }, 500);
    }

    closeCustomNotification() {
        this.customNotification.classList.remove('active');
        this.customNotification.classList.add('hide-notification');
        if(this.customNotification.classList.contains("shown-notification")) {
            this.hideNotification(this.customNotification);
        }
    }

    isOnScreen() {
        return !!(this.customNotification.offsetWidth || this.customNotification.offsetHeight || this.customNotification.getClientRects().length);
    }
}
